'use client';
import { createContext, useContext } from 'react';
import { createI18n, } from '.';
export const I18NContext = createContext({
    language: 'en',
    messages: {},
    t: () => {
        return '';
    },
});
export const useI18N = () => useContext(I18NContext);
export const ClientI18NProvider = ({ children, language, messages, }) => {
    const t = createI18n(messages, language);
    return (<I18NContext.Provider value={{
            language,
            messages,
            t,
        }}>
      {children}
    </I18NContext.Provider>);
};
